export const isImageFile = (mimeType: string) => {
  return mimeType.startsWith("image/");
};
export const IsSoundFile = (mimeType: string) => {
  return mimeType.startsWith("audio");
};

export const IsVideoFile = (mimeType: string) => {
  return mimeType.startsWith("video");
};

export const IsDocumentFile = (mimeType: string) => {
  return mimeType.startsWith("application");
};
